import React from "react";

import LocationIcon from "core/ReusableIcons/Location";

import { Location, LocationText } from "./styles";
import colors from "core/colors";

const ProfileHeaderLocation = ({ city, country }) => {
    if (!city && !country) return null;

    let text = "";

    if (city && !country) text = city;
    if (!city && country) text = country;
    if (city && country) text = `${city}, ${country}`;

    return (
        <Location>
            <LocationIcon fillColor={colors.secondary.dolphin} size="sm" />
            <LocationText>{text}</LocationText>
        </Location>
    );
};

export default ProfileHeaderLocation;
